import template from './tipos-impuestos.html';
import { FormActions } from 'core/services/form';
import tiposImpuestosI18N from 'i18n/tipos-impuestos/es.json';
import { formatErrorMessage } from 'core/util';

export let TiposImpuestosComponent = {
  templateUrl: template,
  selector: 'tiposImpuestos',
  bindings: {
    translations: '='
  },
  controller: TiposImpuestosCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(tiposImpuestosI18N).concat(commonsI18N);

TiposImpuestosCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService'
];

function TiposImpuestosCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService) {

  Object.assign(this, { $state, $ngRedux, ngNotify });
  var defaultColumnOrder = ['nombre', 'porcentaje'];
  var staticFilter = Filter.path('activo').eq(true);
  BasicFactory.setup('tipos-impuestos');

  this.options = {
    staticFilter,
    resource: 'tipos-impuestos',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de tipos de impuestos'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'nombre', title: this.translations['Nombre'] },
      { data: 'porcentaje', title: this.translations['Porcentaje'] }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onRemove: onRemove.bind(this),
    onView: onView.bind(this),
    canEditCondition: AuthorizationService.hasPermission.bind(this, 'update_tipos_impuestos'),
    canRemoveCondition: AuthorizationService.hasPermission.bind(this, 'delete_tipos_impuestos')
  };
  this.mapStateToThis = mapStateToThis.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de tipos de impuestos']
    };
    this.form();
  };
  this.gotoForm = gotoForm.bind(this);


  function mapStateToThis(state) {

    if (state.form.removed) {
      this.ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    return { form: state.form };
  }

  function gotoForm() {
    this.$state.go('home.tipos-impuestos.new');
  }

  function onEdit(itemId) {
    this.$state.go('home.tipos-impuestos.uid.edit', { uid: itemId });
  }

  function onRemove(itemId) {
    this.remove('tipos-impuestos', itemId);
  }

  function onView(itemId) {
    this.$state.go('home.tipos-impuestos.uid.view', { uid: itemId });
  }
}


// WEBPACK FOOTER //
// ./src/components/tipos-impuestos/list/tipos-impuestos.component.js